module.exports = __webpack_public_path__ + "static/media/9.fc74275c.jpg";